import { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from 'styles/table';

export default class Table extends Component {
	static propTypes = {
		content: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.array
		]).isRequired,
		contentHighlight: PropTypes.object,
		title: PropTypes.string,
		tracking: PropTypes.string,
		onHeaderClick: PropTypes.func
	}

	constructor(props) {
		super(props);

		this.handleHeaderClick = this.handleHeaderClick.bind(this);
	}

	handleHeaderClick() {
		if (this.props.onHeaderClick) {
			this.props.onHeaderClick();
		}
	}

	renderTableHeader() {
		return !!this.props.title && (
			<div className={cx(styles.header, {[styles.headerLink]: !!this.props.onHeaderClick})} onClick={this.handleHeaderClick}>
				<span className={styles.title}>{this.props.title}</span>
			</div>
		);
	}

	renderTableList() {
		return (
			<div className={styles.tableList}>
				{this.props.contentHighlight
					&& this.renderTableHighlight()}

				{this.renderTableHeadMedal()}

				<div className={styles.tableBottom}>
					{this.props.content.map((data, index) => {
						return this.renderTableRow(data, index);
					})}
				</div>
			</div>
		);
	}

	renderTableHeadMedal() {
		return (
			<div className={cx(styles.tableTop, styles.tableTopMedals)}>
				<span className={styles.titleTableHead}>Country</span>
				<span className={styles.titleTableHead}>Gold</span>
				<span className={styles.titleTableHead}>Silver</span>
				<span className={styles.titleTableHead}>Bronze</span>
				<span className={styles.titleTableHead}>Total</span>
			</div>
		);
	}

	renderTableRow(data, index) {
		const countryFlagClass = styles[`iconCountry${data.country}`];

		// Ensure we only render rows where we have country flags
		// This is like a whitelist of olympic nations
		return !!countryFlagClass && (
			<div key={index} className={styles.tableRow} data-position={data.position}>
				<span className={cx(styles.iconCountry, countryFlagClass)} />
				<span className={styles.labelCountry}>{data.country}</span>

				{this.renderTableRowMedal(data)}
			</div>
		);
	}

	renderTableRowMedal(data) {
		return (
			<div className={styles.rowResult}>
				<span className={cx(styles.labelCount, styles.labelCountGold)}>{data.gold}</span>
				<span className={cx(styles.labelCount, styles.labelCountSilver)}>{data.silver}</span>
				<span className={cx(styles.labelCount, styles.labelCountBronze)}>{data.bronze}</span>
				<span className={cx(styles.labelCount, styles.labelCountTotal)}>{data.gold + data.silver + data.bronze}</span>
			</div>
		);
	}

	renderTableHighlight() {
		return (
			<div className={styles.tableHighlight}>
				{this.renderTableRow(this.props.contentHighlight)}
			</div>
		);
	}

	render() {
		return (
			<div className={styles.table} data-tracking={this.props.tracking}>
				{this.renderTableHeader()}

				<div className={styles.content}>
					{this.renderTableList()}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/components/Table.es6